// React
import React, { useEffect, useState, useRef } from 'react';
import 'react-tagsinput/react-tagsinput.css';

// Axios
import { generateWithEngine, generationError } from '../gmpGeneration';

// Quill
import ReactQuill, { Quill } from 'react-quill';
import '../style/bubble.css'; // Стандартная тема Quill

// Telegram UI
import { AppRoot, ButtonCell, Cell, Chip, IconContainer, Multiselectable, Select, Section, Slider, Spinner, Navigation, Textarea, Switch } from '@telegram-apps/telegram-ui';

// VK UI & Icons
import { Snackbar, IconButton } from '@vkontakte/vkui';
import { Icon20TextBoldOutline, Icon20TextItalicOutline, Icon20Chain, Icon28ErrorCircleOutline } from '@vkontakte/icons';

// Icons
import { ReactComponent as TempIcon } from "../assets/temp.svg";
import { ReactComponent as TempLowIcon } from "../assets/temp_low.svg";
import { ReactComponent as UnlinkIcon } from "../assets/unlink.svg";
import { ReactComponent as OtherIcon } from "../assets/other.svg";
import { ReactComponent as PromptsIcon } from "../assets/prompts.svg";
import { ReactComponent as TestIcon } from "../assets/test.svg";
import { ReactComponent as DigestIcon } from "../assets/digest.svg";

// Lottie
import Lottie from 'react-lottie';
import generatingPost from '../lotties/magic_wand.json';

// Motion
import { motion } from 'framer-motion';

const tg = window.Telegram.WebApp;

const StylePage = ({ activePanel, setActivePanel, userInfo, FaTelegram, baseTheme, avatarSrc, isMobile, setGptLink, setGptMedia, setGptText, selectedGroup, activeView, setActiveView, premodePosts, stream, setStream }) => {
    const [prompt, setPrompt] = useState(stream.prompt)
    const [temp, setTemp] = useState(stream.temp)
    const [promptLibrary, setPromptLibrary] = useState(null);
    const [sign, setSign] = useState(stream.sign);
    const [digest, setDigest] = useState(stream.digest);
    const [digestNews, setDigestNews] = useState(stream.digest_news);
    const [digestTime, setDigestTime] = useState(stream.digest_timer);
    const promptRef = useRef(null);
    const signRef = useRef(null);

    const [showLoader, setShowLoader] = useState(false);

    // Test Drive

    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState(null);
    const [loadingScreen, setLoadingScreen] = useState('none');

    const [messageIndex, setMessageIndex] = useState(0);
    const [dots, setDots] = useState('');
    const messages = [
        "Ищем новости",
        "Выбираем лучшую",
        "Делаем рерайт",
        "Генерируем пост"
    ];

    const generatingPostOpt = {
        loop: true,
        autoplay: true,
        animationData: generatingPost,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const openError = (text) => {
        setSnackbar(
            <Snackbar
                onClose={() => setSnackbar(null)}
                before={<Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)" />}
            >
                {text}
            </Snackbar>,
        );
    };

    useEffect(() => {
        if (!loadingScreen) return; // Если loadingScreen не true, ничего не делаем

        const interval = setInterval(() => {
            if (messageIndex < messages.length - 1) {
                setMessageIndex(prevIndex => prevIndex + 1);
            }
        }, 2500);

        return () => clearInterval(interval); // Очистка интервала при размонтировании компонента
    }, [loadingScreen, messageIndex]);

    useEffect(() => {
        if (!loadingScreen) return; // Если loadingScreen не true, ничего не делаем

        const dotInterval = setInterval(() => {
            setDots(prevDots => {
                if (prevDots.length < 3) {
                    return prevDots + '.';
                } else {
                    return '';
                }
            });
        }, 500); // Измените интервал, если нужно

        return () => clearInterval(dotInterval); // Очистка интервала при размонтировании компонента
    }, [loadingScreen, messageIndex]);

    const gptTestDrive = async (s_tags, k_tags, n_tags, gptTemp, prompt_input, sign, postForce, token) => {
        console.log("gptTestDrive started");  // Лог для проверки вызова функции
        console.log("Prompt:", prompt_input)
        setLoading(true);
        setLoadingScreen('flex');

        try {
            const response = await generateWithEngine('test-drive', {
                urls: s_tags,
                keywords: k_tags,
                negative: n_tags,
                group_id: selectedGroup.id,
                temp: gptTemp,
                prompt: prompt_input,
                sign: sign,
                force: postForce,
                tg_id: tg.initDataUnsafe.user.id,
                link_original: stream.link_original
            });

            setLoading(false);
            setLoadingScreen('none');
            const summary = response.data.summary.replace(/\\n/g, "\n");
            const title = response.data.title;
            const link = response.data.url;
            const image_url = response.data.image_url;

            setGptLink(link);
            setGptMedia(image_url);
            setGptText(summary);

            setActivePanel('testgpt');

        } catch (error) {
            console.log(error)
            setLoading(false);
            setLoadingScreen('none');
            openError(generationError(error));
        }
    };

    // Quill

    // Создаем пользовательский ссылочный модуль
    const BubbleTheme = Quill.import('themes/bubble');
    const LinkBlot = Quill.import('formats/link');

    class BubbleThemeFix extends BubbleTheme {
        extendToolbar(toolbar) {
            // Вызов оригинального метода
            super.extendToolbar(toolbar);

            // Изменение плейсхолдера
            this.tooltip.textbox.dataset.link = "Введите ссылку...";

            // Проверяем, добавлена ли уже кнопка "Применить"
            if (!this.tooltip.root.querySelector('.applyLink')) {
                // Создание и добавление кнопки
                const applyButton = document.createElement('button');
                applyButton.innerHTML = 'Применить';
                applyButton.className = 'applyLink'
                applyButton.setAttribute('type', 'button');
                this.tooltip.root.querySelector('.ql-tooltip-editor').appendChild(applyButton);

                // Добавление события на клик по кнопке
                applyButton.addEventListener('click', () => {
                    const url = this.tooltip.textbox.value;
                    if (LinkBlot.sanitize(url)) {
                        this.quill.format('link', url);
                        this.tooltip.hide();
                    } else {
                        this.tooltip.hide();
                    }
                });
            }
        }
    }

    // Регистрация новой темы с исправлением
    Quill.register('themes/bubble', BubbleThemeFix, true);

    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'link'],
        ],
    };

    const formats = [
        'bold', 'italic', 'underline', 'link'
    ];

    // Sign
    const [isBold, setIsBold] = useState(false);
    const [isItalic, setIsItalic] = useState(false);
    const [isLink, setIsLink] = useState(false);
    const [showLinkModal, setShowLinkModal] = useState(false);
    const [linkUrl, setLinkUrl] = useState("");
    const editorRef = useRef(null);
    const savedSelection = useRef(null);

    useEffect(() => {
        const handleSelectionChange = () => {
            if (!editorRef.current) return;
            const selection = document.getSelection();
            if (!selection.rangeCount) return;
            let node = selection.anchorNode;
            if (node) {
                if (node.nodeType === 3) node = node.parentNode;
                setIsBold(!!node.closest("b"));
                setIsItalic(!!node.closest("i"));
                setIsLink(!!node.closest("a"));
            }
        };

        document.addEventListener("selectionchange", handleSelectionChange);
        return () => document.removeEventListener("selectionchange", handleSelectionChange);
    }, []);

    const saveSelection = () => {
        const selection = document.getSelection();
        if (selection.rangeCount > 0) {
            savedSelection.current = selection.getRangeAt(0);
        }
    };

    const restoreSelection = () => {
        const selection = document.getSelection();
        selection.removeAllRanges();
        if (savedSelection.current) {
            selection.addRange(savedSelection.current);
        }
    };

    const toggleStyle = (tag) => {
        const selection = document.getSelection();
        if (!selection.rangeCount) return;
        const range = selection.getRangeAt(0);
        const node =
            range.commonAncestorContainer.nodeType === 3
                ? range.commonAncestorContainer.parentNode
                : range.commonAncestorContainer;

        const closestElement = node.closest(tag);
        if (closestElement) {
            // Новое выделение содержимого элемента
            const newRange = document.createRange();
            newRange.selectNodeContents(closestElement);
            selection.removeAllRanges();
            selection.addRange(newRange);
        }

        document.execCommand(tag);
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData("text/html") || e.clipboardData.getData("text/plain");
        const sanitized = text.replace(/<(?!\/?(b|i|u|a)(?=>|\s.*>))\/?.*?>/g, "");
        document.execCommand("insertHTML", false, sanitized);
    };

    const addLink = () => {
        restoreSelection();
        if (linkUrl) {
            document.execCommand("createLink", false, linkUrl);
            setLinkUrl("");
        }
        setShowLinkModal(false);
    };

    const removeLink = () => {
        document.execCommand("unlink");
    };

    const openLinkModal = () => {
        saveSelection();
        setShowLinkModal(true);
    };

    // const checkIfEmpty = () => {
    //     if (editorRef.current && editorRef.current.innerText.trim() === '') {
    //         editorRef.current.classList.add('empty');
    //     } else {
    //         editorRef.current.classList.remove('empty');
    //     }
    // };

    // useEffect(() => {
    //     checkIfEmpty();
    //     if (editorRef.current) {
    //         restoreSelection();
    //     }
    // }, [editorRef]);

    // Other

    const handlePromptChange = (event) => {
        setPrompt(event.target.value);
    };

    useEffect(() => {
        const backButtonHandler = () => {
            tg.HapticFeedback.impactOccurred('heavy');
            tg.HapticFeedback.notificationOccurred("success");
            setActivePanel('channel');
        };

        if (activePanel === 'style') {
            tg.BackButton.show();
            tg.BackButton.onClick(backButtonHandler);
        }

        return () => {
            tg.BackButton.offClick(backButtonHandler);
        };
    }, [activePanel]);

    useEffect(() => {
        if (promptRef.current) {
            promptRef.current.style.height = 'auto';
            promptRef.current.style.height = `${promptRef.current.scrollHeight}px`;
        }
        console.log(stream)
    }, [prompt]);


    useEffect(() => {
        const saveStyle = async () => {
            const url = 'https://api.gmpapp.ru/save_style';

            console.log(selectedGroup.id, stream.id, temp, prompt, sign, stream.promptLibrary)

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ group_id: selectedGroup.id, stream_id: stream.id, temp: temp, prompt: prompt, sign: sign, digest: digest, digest_timer: digestTime, digest_news: digestNews, promptLibrary: stream.promptLibrary }),
                });

                if (!response.ok) {
                    // Здесь можно обрабатывать неуспешные коды ответов
                    tg.BackButton.show();
                    setShowLoader(false);
                    console.error('Error:', response.status, response.statusText);
                } else {
                    // Если ответ успешен, можно сделать что-то с данными
                    tg.BackButton.show();
                    setShowLoader(false);
                    const data = await response.json();
                    console.log('Success:', data);
                    
                    // Оптимистичное обновление
                    stream.prompt = prompt;
                    stream.sign = sign;
                    stream.digest = digest;
                    stream.digest_timer = digestTime;
                    stream.digest_news = digestNews;
                    stream.temp = temp;
                }
            } catch (error) {
                tg.BackButton.show();
                setShowLoader(false);
                console.error('Error streams sending', error);
            }
        };
        
        tg.BackButton.hide();
        setShowLoader(true);
        saveStyle();
    }, [temp, prompt, sign, digest]);

    const handleContextMenu = (event) => {
        event.preventDefault();
    };

    return (
        <div className="wrapperUI">
            <AppRoot platform='ios'>
                <div className="overlaySpinner" style={{ display: loadingScreen }}>
                    <Lottie
                        isClickToPauseDisabled={true}
                        options={generatingPostOpt}
                        height={150}
                        width={150}
                    />
                    <motion.div
                        style={{ paddingTop: "40px" }}
                        key={messageIndex}
                        initial={{ opacity: 0, y: -20 }} // Начальная анимация
                        animate={{ opacity: 1, y: 0 }} // Конечная анимация
                        exit={{ opacity: 0, y: 20 }} // Анимация выхода
                        transition={{ duration: 1 }} // Длительность анимации
                    >
                        <span>{messages[messageIndex]}{dots}</span>
                    </motion.div>
                </div>
                <Section className='sectionChannelStyle' header='Шаблоны'>
                    <Cell onClick={() => { tg.HapticFeedback.impactOccurred('heavy'); tg.HapticFeedback.notificationOccurred("success"); setActivePanel('prompts'); }} className='settingsItem' before={<PromptsIcon className='SettingsItemIcon' />} after={<Navigation />}>Библиотека промптов</Cell>
                </Section>
                <Section className='sectionChannelStyle' header='Промпт' footer='Поле «Промпт» используется для ввода задания модели ChatGPT, задавая нужное направление для автоматического резюмирования новости, как например, указание на основную информацию или экономические последствия. Важно формулировать запрос ясно и точно, чтобы модель могла предоставить необходимое резюме.'>
                    <textarea
                        ref={promptRef}
                        className='sectionPrompt'
                        onChange={e => handlePromptChange(e)}
                        value={prompt}
                        placeholder="Введите промпт..."
                        style={{
                            width: '100%',
                            boxSizing: 'border-box',
                            overflow: 'hidden',
                            padding: '16px',
                            background: 'inherit',
                            border: 'none',
                            borderRadius: 'inherit',
                            color: 'var(--tgui--text_color)',
                            outline: 'none',
                            resize: 'none',
                            fontSize: 'var(--tgui--text--font_size)',
                            lineHeight: 'var(--tgui--text--line_height)',
                            fontWeight: 'var(--tgui--font_weight--accent3)',
                            fontFamily: 'var(--tgui--font-family)'
                        }}
                    />
                    <Cell
                        className='TestDriveCell'
                        subtitle={stream.sources == 0 ? 'Для тест-драйва необходимо добавить источники' : undefined}
                        onClick={stream.sources.length > 0 ? () => {
                            tg.HapticFeedback.impactOccurred('heavy');
                            tg.HapticFeedback.notificationOccurred("success");
                            gptTestDrive(
                                stream.sources,
                                stream.keywords,
                                stream.negative,
                                stream.temp,
                                prompt,
                                stream.sign,
                                stream.force,
                                stream.token
                            );
                        } : null}  // Условный обработчик клика
                        before={<TestIcon className='SettingsItemIcon' />}
                        after={loading ? <Spinner size="s" /> : null}
                        style={{
                            opacity: stream.sources.length > 0 ? undefined : 0.5,
                            cursor: stream.sources.length > 0 ? 'pointer' : 'default'
                        }}
                        multiline
                    >
                        Тест-драйв
                    </Cell>
                </Section>
                <Section className="signSection sectionChannelStyle" header="Подпись" footer="В поле «Подпись» вы можете вставить информацию, которая будет в конце каждого вашего сгенерированного поста. Например, вы можете вставить там призыв подписаться на ваш ресурс или оставить ссылку.">
                    <div onContextMenu={handleContextMenu}>
                        <ReactQuill
                            ref={signRef}
                            value={sign}
                            onChange={setSign}
                            modules={modules}
                            formats={formats}
                            theme="bubble"
                            placeholder="Введите подпись..."
                        />
                    </div>
                </Section>
                <Section className='sectionChannelStyle tempStyle' header="Креативность" footer="Ползунок «Креативность» регулирует, насколько оригинальным и неожиданным будет текст поста. Высокие значения увеличивают вариативность, что может привести к менее предсказуемым результатам">
                    <Slider step={0.1} min={0.4} max={1} before={<IconContainer style={{ color: 'var(--tgui--secondary_hint_color)' }}><TempLowIcon /></IconContainer>} defaultValue={temp} onChange={e => setTemp(e)} after={<IconContainer style={{ color: '#2688eb' }}><TempIcon /></IconContainer>} />
                </Section>
                {snackbar}
                {showLoader && (
                    <Spinner className="saveLoader" size="m" />
                )}
            </AppRoot>
        </div>
    );
};

export default StylePage;
